import {
  fetchHoldTimeoutMs,
} from './chatSettings';

const temporaryFetchHold = (dispatch, isMountedRef) => {
  setTimeout(
    () => { if (isMountedRef.current) dispatch({ type: 'endFetchHold' }); },
    fetchHoldTimeoutMs,
  );
};

export default temporaryFetchHold;
